import React from 'react';

import { DialogActions } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

import { useTranslation } from 'next-i18next';

import Button from 'src/components/ui/Button';
import Dialog from 'src/components/ui/Dialog';

import useAlerts from 'src/hooks/useAlerts';

import { useDeletePostMutation } from 'src/hooks/__generated__/queries';
import { styledComponent } from 'src/utils/styled';

const StyledDialog = styledComponent(Dialog)`
    .MuiDialog-paper {
        width: 100%;
    }
    .MuiDialogTitle-root {
        padding: 1.25rem 1.5rem 0.75rem 1.5rem;
    }
    .MuiDialogActions-root {
        padding: 0.5rem 1.5rem 1.5rem 1.5rem;
    }
`;
StyledDialog.defaultProps = {
    maxWidth: 'xs',
};

interface Props {
    onClose: () => void;
    open: boolean;
    postId: string;
}

const DeletePostModal: React.FC<Props> = ({ postId, onClose, open }) => {
    const { t } = useTranslation(['news', 'profile', 'common']);
    const { addAlert } = useAlerts();

    const [deletePost] = useDeletePostMutation();

    const handleClose = () => {
        onClose();
    };

    const handleDeletePost = async () => {
        await deletePost({
            variables: {
                postId,
            },
            refetchQueries: ['Posts', 'NewsFeed'],
            awaitRefetchQueries: true,
        });
        handleClose();
        addAlert({
            type: 'success',
            message: t('news:deletePostSuccess'),
        });
    };

    return (
        <StyledDialog open={open} onClose={handleClose}>
            <DialogContent>
                <DialogContentText>{t('news:deletePostConfirmContent')}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={handleClose}
                    data-target="btn-post-delete-cancel"
                    data-target-id={`btn-post-delete-cancel-id-${postId}`}
                >
                    {t('common:modal.cancel')}
                </Button>
                <Button
                    onClick={handleDeletePost}
                    data-target="btn-post-delete-confirm"
                    data-target-id={`btn-post-delete-confirm-id-${postId}`}
                >
                    {t('news:deletePostConfirmConfirm')}
                </Button>
            </DialogActions>
        </StyledDialog>
    );
};

export default DeletePostModal;
